import { PASSENGER_STATUS_ONBOARD, SHIFT_STATUS_ONGOING } from '../constants.ts';
import { RoadmapMessage } from '../schema/Message.ts';
import { Shift } from '../schema/Shift.ts';
import { IVehicle } from '../schema/Vehicle.ts';

export function getAutomataOffButtonColor(vehicle: IVehicle | undefined): string {
  let color = 'primary';
  if (vehicle?.shift?.status === SHIFT_STATUS_ONGOING && vehicle?.is_online) {
    color = 'danger';
  }
  return color;
}

export function getOccupiedSeatsCount(roadmap: RoadmapMessage): number {
  const onboardBookingsList = roadmap.places.flatMap(place =>
    place.bookings.filter(booking => booking.passenger_status === PASSENGER_STATUS_ONBOARD),
  );
  const uniqueBookingsList = onboardBookingsList.filter(
    (obj1, i, arr) => arr.findIndex(obj2 => obj2.id === obj1.id) === i,
  );
  return uniqueBookingsList.reduce((sum, booking) => sum + booking.requested_seats, 0);
}

export function formatShiftDates(shift: Shift): string {
  const startDatetime = new Date(shift.start_datetime);
  const endDatetime = new Date(shift.end_datetime);
  const localDate1 = startDatetime.toLocaleDateString();
  const hour1 = startDatetime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  const hour2 = endDatetime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  // TODO - consider when end date is different from start date -> display end date as well
  return `${localDate1} : (${hour1} <-> ${hour2})`;
}
